import { Tab } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomTabs } from '../../../components/Forms/CustomTabs';
import AgreementMenu from "../../../components/IApprovalRessourceMenu";
import UseUrlParam from "../../../components/Logic/UseUrlProps";
import TabPanel from "../../../components/TabPanel";
import AgreementRequest from "../../../models/Agreement";
import { useAddApprovalMutation, useAddDenialMutation, useDeleteAgreementMutation, useGetAgreementByIdQuery } from "../redux/agreementsApiSlice";
import ContactsTab from "./tabs/ContactsTab";
import InfoTab from "./tabs/InfoTab";
import IpAddressesTab from "./tabs/IpAddressesTab";

interface AgreementInfoDialogProps {
    agreement: AgreementRequest
    onClose?: () => void
    afterDeleteAction?: () => void
}

export const AgreementInfoDialog = (props: AgreementInfoDialogProps | UseUrlParam) => {

    const params = useParams();
    const urlPropsUuid = (props as UseUrlParam).shouldGetEntityFromUrl ? params["agreementUuid"] : "";
    const agreementPropsUuid = (props as AgreementInfoDialogProps).agreement?.uuid

    const serviceUuid = agreementPropsUuid ?? urlPropsUuid;

    const [value, setValue] = React.useState(0);
    const { t } = useTranslation();
    const { data } = useGetAgreementByIdQuery(serviceUuid!)

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    if (data == undefined)
        return <></>

    const labels = []
    const tabPanel = []

    labels.push(t("Info") + "")
    tabPanel.push(<TabPanel value={value} index={tabPanel.length}><InfoTab agreementId={data.uuid!} {...props} /></TabPanel>)

    labels.push(t("Client Ip addresses") + "")
    tabPanel.push(<TabPanel value={value} index={tabPanel.length}><IpAddressesTab agreementId={data.uuid!} {...props} /></TabPanel>)

    labels.push(t("Contacts") + "")
    tabPanel.push(<TabPanel value={value} index={tabPanel.length}><ContactsTab agreementId={data.uuid!} {...props} /></TabPanel>)

    return (
        <>

            <CustomTabs
                value={value}
                onChange={handleChange}
                rightMenu={
                    <AgreementMenu
                        nameOfRessource="agreement"
                        primaryButtonText={t("Agreement") + ": " + data.client?.name + " (" + data.service?.name + ")"}
                        idToFetch={data.uuid}
                        getByIdAction={useGetAgreementByIdQuery}
                        approveMutation={useAddApprovalMutation}
                        denyMutation={useAddDenialMutation}
                        terminateMutation={useDeleteAgreementMutation}
                        afterDeleteAction={(props as AgreementInfoDialogProps).afterDeleteAction}
                    />}>
                {labels.map(label => (<Tab key={label} label={label} />))}
            </CustomTabs>
            {tabPanel.map(tabPanel => tabPanel)}
        </>
    )
}